import { render } from "./DocSwagger.vue?vue&type=template&id=0b46c77f"
import script from "./DocSwagger.vue?vue&type=script&lang=js"
export * from "./DocSwagger.vue?vue&type=script&lang=js"

import "./DocSwagger.vue?vue&type=style&index=0&id=0b46c77f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__